import { AxiosResponse } from "axios";
import http from "utilities/http-common";

const baseUrl = "/api/Connective";

interface Action {
  Type: string;
  Elements: any[];
  RedirectUrl?: string;
  RedirectType?: string;
  BackButtonUrl?: string;
  Result?: any;
  StakeholderId: string;
  Id: string;
  SuppressNotifications: boolean;
  Status: string;
  Links: string[];
  MemberLinks: any[];
}

export async function getPackageStatus(packageId: string): Promise<string> {
  return await http
    .get(`${baseUrl}/${packageId}/status`)
    .then((resp: AxiosResponse) => {
      return resp.data;
    });
}

export async function getPackageRemainingActions(
  packageId: string
): Promise<string[]> {
  return await http
    .get(`${baseUrl}/${packageId}/remaining-actions`)
    .then((resp: AxiosResponse<Action[]>) => {
      if (resp.data[0].Status === "Finished") {
        return resp.data[1].Links;
      }
      return resp.data[0].Links;
      // return resp.data.map((action: Action) => action.Links[0]);
    })
}

export async function getPackageRemainingActionsEmployee(
  packageId: string
): Promise<string[]> {
  return await http
    .get(`${baseUrl}/employee/${packageId}/remaining-actions`)
    .then((res: AxiosResponse<string[]>) => {
      return res.data;
    })
}

export async function getPackageRemainingActionsCertificate(
  packageId: string
): Promise<string[]> {
  return await http
    .get(`${baseUrl}/employee/certificate/${packageId}/remaining-actions`)
    .then((res: AxiosResponse<string[]>) => {
      return res.data;
    })
}

export async function getConfidentialityAgreementRemainingActions(
  applicationId: string
): Promise<string[]> {
  return await http
    .get(`${baseUrl}/employee/certificate/${applicationId}/confidentiality-agreement/remaining-actions`)
    .then((res: AxiosResponse<string[]>) => {
      return res.data;
    })
}

export async function getPackagePreviewLink(packageId: string, type: string): Promise<string> {
  return await http
    .get(`${baseUrl}/employee/${packageId}/preview/${type}`)
    .then((resp: AxiosResponse<string>) => {
      return resp.data;
    });
}